import {AmenityGroupType} from "@CheckOrder/features/amenities/types/AmenityGroup.type";

/**
 * Used while pairing single and return amenity groups
 * takes each (not already added) amenity key from amenityGroup and adds them in existing keys array
 */
export default function appendAmenityKeysList(amenityGroup: AmenityGroupType, amenityKeysArray: string[]) {
    const newAmenityKeys = amenityGroup.amenities.filter((amenity) => (
        !amenityKeysArray.includes(amenity.key)
    )).map((amenity) => (amenity.key))

    return [...amenityKeysArray, ...newAmenityKeys]
}